export const FETCH_TIMEOFF_TYPE = 'FETCH_TIMEOFF_TYPE';
export const TIMEOFF_TYPE_RECEIVED = 'TIMEOFF_TYPE_RECEIVED'
export const FETCH_UNAVAILABLE_TIMEOFF_DATES = 'FETCH_UNAVAILABLE_TIMEOFF_DATES';
export const UNAVAILABLE_TIMEOFF_DATES_RECIEVED = 'UNAVAILABLE_TIMEOFF_DATES_RECIEVED';
export const FETCH_PTO_BALANCE = 'FETCH_PTO_BALANCE';
export const PTO_BALANCE_RECIEVED = 'PTO_BALANCE_RECIEVED';
export const DATETIME_FORMAT = 'MM/DD/YYYY';
export const POST_REQUEST_TIMEOFF = 'POST_REQUEST_TIMEOFF'
export const REQUEST_TIMEOFF_COMPLETED = 'REQUEST_TIMEOFF_COMPLETED'
export const FETCH_REQUEST = 'FETCH_REQUEST'
export const REQUEST_RECIEVED = 'REQUEST_RECIEVED'
export const PUT_REQUEST_TIMEOFF = 'PUT_REQUEST_TIMEOFF'
export const CANCEL_REQUEST_TIMEOFF = 'CANCEL_REQUEST_TIMEOFF'
export const FETCH_ALL_MU = 'FETCH_ALL_MU';
export const RECEIVED_ALL_MU = 'RECEIVED_ALL_MU';
export const FETCH_TIME_OFF_ENUM = 'FETCH_TIME_OFF_ENUM';
export const RECEIVED_TIME_OFF_ENUM = 'RECEIVED_TIME_OFF_ENUM';
export const FETCH_CURRENT_REQUESTS = 'FETCH_PENDING_REQUESTS';
export const RECEIVED_CURRENT_REQUESTS = 'RECEIVED_PENDING_REQUESTS';
export const FETCH_TIMEOFF_SUMMARY = 'FETCH_TIMEOFF_SUMMARY';
export const FETCH_NEXT_ACCRUAL_DATE = 'FETCH_NEXT_ACCRUAL_DATE';
export const RECEIVED_NEXT_ACCRUAL_DATE = 'RECEIVED_NEXT_ACCRUAL_DATE';
export const RECEIVED_TIME_OFF_SUMMARY = 'RECEIVED_TIME_OFF_SUMMARY';	
export const FETCH_PTO_SPOTS = 'FETCH_PTO_SPOTS';
export const PTO_SPOTS_RECIEVED = 'PTO_SPOTS_RECIEVED';
export const PATCH_REQUEST_TIMEOFF = 'PATCH_REQUEST_TIMEOFF'
export const PATCH_REQUEST_TIMEOFF_COMPLETED = 'PATCH_REQUEST_TIMEOFF_COMPLETED'
export const RECEIVED_APPROVED_REQUESTS = 'RECEIVED_APPROVED_REQUESTS'
export const FETCH_REQUEST_STATUS_ENUM = 'FETCH_REQUEST_STATUS_ENUM';
export const RECEIVED_REQUEST_STATUS_ENUM = 'RECEIVED_REQUEST_STATUS_ENUM';

//notifications
export const FETCH_NOTIFICATION_TYPE_ENUM = 'FETCH_NOTIFICATION_TYPE_ENUM';
export const RECEIVED_NOTIFICATION_TYPE_ENUM = 'RECEIVED_NOTIFICATION_TYPE_ENUM';
export const FILTER_REQUESTS='FILTER_REQUESTS';


// WEBPACK FOOTER //
// ./src/features/timeoff/redux/constants.js